import type { Coach } from '@entities/coaches/index';
import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { checkDescription } from '@widgets/shared/descriptionEditor/helpers.ts';
import {
  SCard,
  SCoachAvatar,
  SCoachAvatarLargeContainer,
  SContactsTitle,
  SNameAndSpecialization,
  SPhotoAndDescription,
  SSName,
  SSSpecialization,
  STitle,
} from '@features/coaches/coachCard/Large/styles';
import { Contacts } from '@features/event-page';
import { VideosIcon } from '@shared/assets/index';
import { getFullNameM } from '@shared/helpers/index';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import * as st from './styles.module.scss';

export const CoachCardLarge = memo(
  ({
    photo,
    first_name,
    middle_name,
    last_name,
    description,
    active_contacts,
    coach_video,
    partitions,
  }: Partial<Coach>) => {
    // const specialization = useMemo(() => getSpecialization(tags), [tags]);
    const coachName = useMemo(
      () => getFullNameM(first_name, middle_name, last_name),
      [first_name, middle_name, last_name]
    );

    return (
      <SCard>
        <SPhotoAndDescription>
          <SCoachAvatarLargeContainer>
            <SCoachAvatar size={'large'} photo={photo} imgClassName={photo && st.coachPhoto}>
              {coach_video && (
                <Link to={`${coach_video.id}`}>
                  <VideosIcon />
                </Link>
              )}
            </SCoachAvatar>
          </SCoachAvatarLargeContainer>

          <SNameAndSpecialization>
            <SSName>{coachName}</SSName>

            {partitions?.length && (
              <SSSpecialization>{partitions.map((p) => p.name).join(', ')}</SSSpecialization>
            )}
          </SNameAndSpecialization>
        </SPhotoAndDescription>

        {description && checkDescription(description) && (
          <>
            <STitle $shouldHideOnMobileL>Обо мне</STitle>
            <DescriptionViewer description={description} />
            {/*<ViewerNoteEditorContent htmlString={description} type="profile" />*/}

            {/* <SFullDescription>{description}</SFullDescription> */}
          </>
        )}

        {active_contacts && active_contacts?.length !== 0 && (
          <>
            <SContactsTitle>Контакты</SContactsTitle>
            <Contacts contacts={active_contacts} isSpecialist />
            {/* <SContacts>
              {active_contacts?.map(
                (c) =>
                  !!c.value && (
                    <SContact
                      $isActive={!!c.base_url}
                      key={c.id}
                      onClick={() => c.base_url && window.open(c.base_url, '_blank')}
                    >
                      <SIconButton>{contactIconsMap[c.type]}</SIconButton>

                      <STextOverflowCss>
                        {c.type === 'phone' ? c.formated_phone : c.value}
                      </STextOverflowCss>
                    </SContact>
                  )
              )}
            </SContacts> */}
          </>
        )}
      </SCard>
    );
  }
);
